import React from 'react';
import CategoryRow from '../CategoryRow';

const Grocery = () => (
  <CategoryRow title="Grocery" category="Grocery" exploreTo="/all-grocery-item" />
);

export default Grocery;
